


































































































import { Libro } from "@/data/models/biblioteca.model";
import { BibliotecaService } from "@/data/services/biblioteca.service";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class LibroDetailCard extends Vue {
  @Inject("BibliotecaService") bibliotecaService!: BibliotecaService;

  @Prop() libro!: Libro;

  coverUrl: string | null = null;

  /**
   * Metti true se vuoi mostrare anche editore, ISBN,
   * collocazione, prestito e note.
   */
  showExtraFields = false;

  mounted() {
    this.loadCover();
  }

  @Watch("libro", { immediate: false, deep: false })
  onLibroChange() {
    this.loadCover();
  }

  get inPrestitoText(): string {
    if (this.libro.inprestito === undefined) {
      return "-";
    }

    return this.libro.inprestito ? "Si" : "No";
  }

  loadCover() {
    this.clearCoverUrl();

    if (!this.libro.cover) {
      return;
    }

    this.bibliotecaService.downloadCover(this.libro.cover).then((blob) => {
      this.coverUrl = URL.createObjectURL(blob);
    });
  }

  clearCoverUrl() {
    if (this.coverUrl) {
      URL.revokeObjectURL(this.coverUrl);
      this.coverUrl = null;
    }
  }

  beforeDestroy() {
    this.clearCoverUrl();
  }
}
